export default __webpack_public_path__ + "static/media/plant-diary-preview.a298a438.png";